<template>
    <div style="background:#F2F2F2">
        <v-container>
            <v-layout row justify-center class="mt-3 mb-3">
                <v-flex xs12 md6 class="my-2">
                    <div style="border:soldi 1px #000;width:90%;margin:0 auto;display:block;">
                        <video 
                        style="border:soldi 1px #000"
                        height="576" controls width="100%">

                    <source src="https://pipemein.com/videos/tiktok0.mp4"
                            type="video/mp4">
                </video>
                    </div>
                </v-flex>
                <v-flex xs12 md6 class="my-2">
                    <div style="width:90%;margin:0 auto;display:block;">
                        <video 
                        style="border:soldi 1px #000"
                        height="576" controls width="100%">

                    <source src="https://pipemein.com/videos/tiktok1.mp4"
                            type="video/mp4">
                </video>
                    </div>
                </v-flex>
            </v-layout>
            
            
        </v-container>
        <router-link style="text-decoration:none;" to="/Details/Product/NEarkSljLxYlDxoCYLZy">
        <v-parallax src="https://pipemein.com/files/pipemein/image/productsdesc.jpg" height="300">
        </v-parallax></router-link>
        
    </div>
</template>

<script>
export default {
    
    data() {
        return {
            
        }
    },

}
</script>
